import { post } from "jquery";
import Swal from "sweetalert2";
import { BlockPageHelper } from "../Helpers/helpers";
import { WorkflowWorkOrderApproveConditionHandler } from "./WorkflowWorkOrderApproveConditionHandler";
import { WOWorkflowActionNames } from "../WorkOrder/WOWorkflowActionNames";

const Genesis = require("../Genesis.js");

export class WorkflowHandler {
    private static validationHandlers = [
        function _defaultHandler (result: any, recordId: number, actionName: string, containerSelector: string) {
            if (result.message) {
                Swal.fire({ text: result.message });
            }
            return true;

        }];

    public static registerHandler(handler: any) {
        this.validationHandlers.unshift(handler);
    };

    public static InitWorkflowButtons() {
        const buttonPlaceholder = $("#workflow-buttons");
        const data = {
            recordId: buttonPlaceholder.data('record-id'),
            recordTypeId: buttonPlaceholder.data('record-type-id'),
            workOrderTypeSystemCode: buttonPlaceholder.data('work-order-type-system-code'),
            showRiskAssessmentButton: buttonPlaceholder.data('show-riskassessment-button'),
        }
        
        $.ajax({
            type: "get",
            cache: false,
            url: Genesis.url('/Workflow/WorkflowButtons'),
            data: data            
        }).done(function (html) {
            buttonPlaceholder.after(html);
            $(".workflowActionButton").each(function (index: number) {
                $(this).click(() => WorkflowHandler.handleActionButton(event, $(this).data("id"), $(this).data("action")));
            });
            $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_ConfirmRiskAssessmentPassed}']`).parent().hide();
            $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_StartWorkRAPassed}']`).parent().hide();
            $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_RiskAssessmentFailed}']`).parent().hide();
            $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_StartWorkNoRA}']`).parent().hide();
            $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_CancelWorkOrder}']`).parent().hide();
            $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_CancelWorkOrderAndCloseSR}']`).parent().hide();
        });        
    }

    public static disableButtons() {
        $(".workflowActionButton").each(function (index: number) {
            $(this).attr('disabled','');
        });
    }

    public static handleActionButton(event: any, recordId: number, actionName: string, reloadAfterPost = true, redirectAfterPostUrl = ''): boolean {
        BlockPageHelper.block();        
        post({
            url: Genesis.url('Workflow/Action'),
            data: {
                recordId: recordId,
                actionName: actionName 
            },
        }).then((result) => {
            if (result && result.success) {
                if (reloadAfterPost && redirectAfterPostUrl === '') {                    
                    location.reload();
                }
                if (redirectAfterPostUrl !== '') {
                    location.href = redirectAfterPostUrl;
                }
            } else {
                this.runValidationHandlers(result, recordId, actionName, '.content');
            }
            BlockPageHelper.unblock();
        }).catch(function () {
            BlockPageHelper.unblock();
        });        
        return false;
    }

    private static runValidationHandlers(result: any, recordId: number, actionName: string, containerSelector: string) {
        for (let i = 0; i < this.validationHandlers.length; ++i) {
            if (this.validationHandlers[i] && this.validationHandlers[i](result, recordId, actionName, containerSelector)) {
                break;
            }
        }
    };
}

$(document).ready(() => {
    (new WorkflowWorkOrderApproveConditionHandler()).registerHandler();
});